module.exports = __webpack_public_path__ + "img/search-header-with-nav-lincoln.4905ffc5.png";